/**
 * Toggle Nav
 * ======================================
 * - toggle class on body
 */
const ELEMENTS = '.js-nav'
const TOGGLE_CLASS = 'nav-is-open'

class ToggleNav {
  constructor() {
    this.elements = document.querySelectorAll(ELEMENTS)
    this.allitems = document.querySelectorAll('ul.nav a')
    this.sub = document.querySelectorAll('ul.nav li.has-children > a')
    this.items = document.querySelectorAll('ul.nav li.without-children > a')

    if (!this.elements) {
      return false
    }

    this.elements.forEach((el) => {
      el.addEventListener('click', this.toggleNav, false)
    })

    if(window.matchMedia("(max-width: 1023px)").matches){
      this.sub.forEach((el) => {
        el.addEventListener('click', this.toggleSub, false)
      })

      this.items.forEach((el) => {
        el.addEventListener('click', this.closeNav, false)
      })
    } else {
      this.allitems.forEach((el) => {
        el.addEventListener('click', this.scrollTo, false)
      })
    }
  }

  toggleNav() {
    document.body.classList.toggle(TOGGLE_CLASS)
    document.body.classList.toggle('lock')
  }

  closeNav = () =>  {
    document.body.classList.remove(TOGGLE_CLASS)
    document.body.classList.remove('lock')
  }

  scrollTo = (e) =>  {
    if (!document.body.classList.contains('is-scrolled')) {
      e.preventDefault()

      document.body.classList.add('is-scrolled')

      const href = e.currentTarget.getAttribute('href')

      setTimeout(function(){
        window.location = href;
       }, 350);
    }
  }

  toggleSub = (e) => {
    const el = e.currentTarget
    const children = el.parentNode.querySelector('ul')

    children.classList.toggle('is-open')

    e.preventDefault()
  }
}

new ToggleNav()
